<markant-platform-simple-widget-with-action>
  <span slot="widget-headline">{{ serviceVariant()?.name }}</span>
  <span slot="widget-text-title">
    {{ 'platformWidget.blockedService.textTitle' | transloco }}
  </span>
  <span *ngIf="userType() === 'SERVICE_MANAGER'" slot="widget-text-body">
    {{ 'platformWidget.blockedService.serviceManager.text' | transloco }}
  </span>
  <markant-button
    *ngIf="userType() === 'SERVICE_MANAGER'"
    [routerLink]="['cartridge', 'catalog', service()?.id, 'detail']"
    slot="widget-button"
    variant="clear"
  >
    {{ 'platformWidget.blockedService.serviceManager.button' | transloco }}
  </markant-button>
  <span *ngIf="userType() === 'SERVICE_MANAGER_ECS'" slot="widget-text-body">
    {{ 'platformWidget.blockedService.serviceManagerEcs.text' | transloco }}
  </span>
  <markant-button
    *ngIf="userType() === 'SERVICE_MANAGER_ECS'"
    (click)="contactRequestDialogOpen.set(true)"
    slot="widget-button"
    variant="clear"
  >
    {{ 'platformWidget.blockedService.serviceManagerEcs.button' | transloco }}
  </markant-button>
  <span *ngIf="userType() === 'NON_SERVICE_MANAGER'" slot="widget-text-body">
    {{
      'platformWidget.blockedService.nonServiceManager.text'
        | transloco: { serviceManagerName: serviceManagerName() }
    }}
  </span>
</markant-platform-simple-widget-with-action>
@if (contactRequestDialogOpen()) {
  <markant-platform-modal-bridge>
    <markant-platform-contact-request-dialog
      [open]="true"
      [requestStateOnSubmit]="requestSucceeded$"
      (openChange)="contactRequestDialogOpen.set($event)"
      (isApproved)="sendContactRequest()"
    >
    </markant-platform-contact-request-dialog>
  </markant-platform-modal-bridge>
}
